/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type { GetCreditBalanceQueryResponse } from '../../types/GetCreditBalance'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getCreditBalance } from '../../clients/getCreditBalance'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getCreditBalanceQueryKey = () =>
  [{ url: '/api/v1/contact_request/credits/' }] as const

export type GetCreditBalanceQueryKey = ReturnType<
  typeof getCreditBalanceQueryKey
>

export function getCreditBalanceQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getCreditBalanceQueryKey()
  return queryOptions<
    GetCreditBalanceQueryResponse,
    ResponseErrorConfig<Error>,
    GetCreditBalanceQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getCreditBalance({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @description Get credit balance from our database
 * @summary Get the company's contact-credit balance
 * {@link /api/v1/contact_request/credits/}
 */
export function useGetCreditBalance<
  TData = GetCreditBalanceQueryResponse,
  TQueryData = GetCreditBalanceQueryResponse,
  TQueryKey extends QueryKey = GetCreditBalanceQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetCreditBalanceQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getCreditBalanceQueryKey()

  const query = useQuery(
    {
      ...getCreditBalanceQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
